import React from 'react';
import Avatar from '../../../components/thread/avatar/Avatar';

function ProfileImageAvatars({ signedUrl, name, ...rest }) {
    return signedUrl ? <Avatar url={signedUrl} {...rest} /> : <Avatar name={name} {...rest} />;
}

export default ProfileImageAvatars;
